<template>
  <div class="mt-6">
    <v-row no-gutters>
      <v-col>
        <v-row class="checkout-h6" style="font-weight: 700" no-gutters>
          {{ $t("participants.participants") }}
        </v-row>
        <v-row class="checkout-h5 accent--text" no-gutters>
          {{ $t("participants.details") }}
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
      <v-btn
        v-if="
          !paymentScreen &&
          !eventDetails.checkout_nomeacao_obrigatoria &&
          !isCourtesy
        "
        text
        color="primary"
        rounded
        @click="goPayment"
        >{{ $t("participants.jump") }}</v-btn
      >
    </v-row>
    <v-row
      v-if="paymentScreen && !eventDetails.checkout_nomeacao_obrigatoria"
      no-gutters
      class="mt-4"
    >
      <span class="checkout-h4 accent--text">{{
        $t("participants.optional")
      }}</span></v-row
    >
    <div class="mt-4" v-if="orderDetails">
      <v-form ref="form" v-model="valid">
        <div
          v-for="(ticket, i) in orderDetails.ingressos.filter(
            (i) => i.dados_extras.length
          )"
          :key="i"
          :class="paymentScreen ? '' : 'mb-6'"
        >
          <v-row align="center" class="pb-6" no-gutters>
            <div class="circle-number">{{ i + 1 }}</div>
            <span class="checkout-h3"
              >{{ ticket.nome_produto }} - {{ ticket.tipo }}</span
            >
          </v-row>
          <NominationForm
            v-for="(option, index) in ticket.dados_extras"
            :options="ticket.dados_extras"
            :key="index"
            :option="option"
          />
        </div>
      </v-form>
    </div>
    <v-row v-if="!paymentScreen" no-gutters justify="center">
      <v-btn
        v-if="!$route.query.order_hash"
        class="mr-2"
        rounded
        outlined
        color="primary"
        width="100"
        height="40"
        @click="backCart"
        >{{ $t("participants.back") }}</v-btn
      >
      <v-col>
        <v-btn
          @click="saveNomination"
          :loading="loading"
          rounded
          depressed
          :disabled="!valid"
          width="100%"
          height="40"
          color="primary"
          >{{ $t("participants.continue") }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NominationForm from "./NominationForm.vue";
export default {
  props: ["paymentScreen"],
  components: { NominationForm },
  data() {
    return {
      loading: false,
      valid: false,
    };
  },
  computed: {
    ...mapGetters([
      "orderDetails",
      "productsDetails",
      "noSectorList",
      "canPurchase",
      "eventDetails",
      "selectedSector",
      "productsTotal",
      "buyer",
      "eventId",
      "widgetMode",
    ]),

    isCourtesy() {
      return this.productsTotal === 0;
    },
  },
  watch: {
    valid(v) {
      this.$store.commit("SET_NOMINATION_VALID", v);
    },
  },
  methods: {
    backCart() {
      this.$store.commit("SET_ORDER_DETAILS", null);
      localStorage.removeItem(`cart-order-route-${this.eventId}`);
      if (this.widgetMode) {
        this.$store.commit("SET_STEP", "Cart");
      } else {
        this.$router.push({
          name: "Cart",
          params: { event: this.eventId },
          query: this.$route.query,
        });
      }
    },
    setStorage() {
      let obj = {
        order: this.orderDetails,
        productsDetails: this.productsDetails,
        cart: this.noSectorList,
        selectedSector: this.selectedSector,
        route: "Payment",
      };
      localStorage.setItem(
        `cart-order-route-${this.eventId}`,
        JSON.stringify(obj)
      );
    },
    goPayment() {
      this.setStorage();
      let route = {
        name: "Payment",
        params: { event: this.eventId },
        query: this.$route.query,
      };

      if (this.widgetMode) {
        this.$store.commit("SET_STEP", "Payment");
      } else this.$router.push(route);
    },

    async goToFinishedScreen() {
      let params = {
        buyer: {
          ...this.buyer,
          customer_phone: "",
        },
        event: this.eventId,
        order: this.orderDetails.codigo,
      };

      if (this.orderDetails?.ingressos?.length === 1) {
        let ticket = this.orderDetails?.ingressos[0];

        const getExtraDataValue = (type) => {
          return (
            ticket?.dados_extras?.find((tde) => tde.tipo === type)?.valor || ""
          );
        };

        let customer = {};

        customer.customer_name = getExtraDataValue("nome");
        customer.customer_email = getExtraDataValue("email");
        customer.customer_phone = getExtraDataValue("telefone");
        customer.customer_doc = getExtraDataValue("documentos");

        params.customer = customer;
      }

      await this.$store
        .dispatch("confirmOrder", params)
        .then((resp) => {
          if (resp && resp.success) {
            if (this.widgetMode) {
              this.$store.commit("SET_STEP", "Finished");
            } else {
              this.$router.push({
                name: "Finished",
                params: { event: this.eventId },
                query: this.$route.query,
              });
            }
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 410)
            this.loading = false;
        });
      this.loading = false;
    },

    async saveNomination() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "saveNamedTicket",
          this.orderDetails.ingressos
        );

        if (this.isCourtesy) await this.goToFinishedScreen();
        if (!this.isCourtesy) this.goPayment();
      } catch (e) {
        this.$store.dispatch("openSnackbar", {
          message: e?.response?.data?.message || "Erro na nomeação",
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.participants-title {
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: -0.5px;
  color: var(-v--accent-base);
}

.circle-number {
  border: 1px solid #0067af;
  border-radius: 50%;
  height: 32px;
  width: 32px;
  line-height: 31px;
  font-size: 18px;
  font-weight: 500;
  max-width: 32px;
  letter-spacing: 0.15px;
  color: #0067af;
  text-align: center;
  margin-right: 12px;
}
</style>
